import React, { useState, useContext } from 'react';
import axios from 'axios';
import { API, AuthContext } from '../App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Key, User, Mail, Shield } from 'lucide-react';
import { toast } from 'sonner';

export const Settings = () => {
  const { user } = useContext(AuthContext);
  const [passwordData, setPasswordData] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!passwordData.current_password || !passwordData.new_password) { toast.error('Fyll ut alle felt'); return; }
    if (passwordData.new_password !== passwordData.confirm_password) { toast.error('Passordene stemmer ikke overens'); return; }
    if (passwordData.new_password.length < 6) { toast.error('Passordet må være minst 6 tegn'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: passwordData.current_password, new_password: passwordData.new_password });
      toast.success('Passord endret!');
      setPasswordData({ current_password: '', new_password: '', confirm_password: '' });
    } catch (error) { toast.error(error.response?.data?.detail || 'Kunne ikke endre passord'); }
    finally { setLoading(false); }
  };

  const getRoleName = (role) => {
    switch (role) {
      case 'system_admin': return 'Systemadministrator';
      case 'admin': return 'Administrator';
      case 'tekniker': return 'Tekniker';
      default: return role;
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>Innstillinger</h1>
        <p className="text-slate-600">Administrer din konto</p>
      </div>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><User className="h-5 w-5 text-slate-600" />Min Profil</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <User className="h-5 w-5 text-slate-400" />
              <div><p className="text-sm text-slate-500">Navn</p><p className="font-medium text-slate-900">{user?.name}</p></div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Mail className="h-5 w-5 text-slate-400" />
              <div><p className="text-sm text-slate-500">E-post</p><p className="font-medium text-slate-900">{user?.email}</p></div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Shield className="h-5 w-5 text-slate-400" />
              <div><p className="text-sm text-slate-500">Rolle</p><p className="font-medium text-slate-900">{getRoleName(user?.role)}</p></div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Key className="h-5 w-5 text-slate-600" />Endre Passord</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleChangePassword} className="space-y-4">
            <div className="space-y-2"><Label>Nåværende passord</Label><Input type="password" value={passwordData.current_password} onChange={(e) => setPasswordData({ ...passwordData, current_password: e.target.value })} placeholder="Skriv inn nåværende passord" /></div>
            <div className="space-y-2"><Label>Nytt passord</Label><Input type="password" value={passwordData.new_password} onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })} placeholder="Minimum 6 tegn" /></div>
            <div className="space-y-2"><Label>Bekreft nytt passord</Label><Input type="password" value={passwordData.confirm_password} onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })} placeholder="Skriv inn passordet på nytt" /></div>
            <Button type="submit" className="w-full bg-slate-900 hover:bg-slate-800" disabled={loading}>{loading ? 'Endrer...' : 'Endre Passord'}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Settings;
